export const spekwoType = {
  testOrder: 'No product selected Bec Its test order',
  head: 'Solution Estimate',
  headForOther: 'Request Details',
  reportId: 'Report Id is :',
  orderDetails: 'Order Details',
  homeIns: 'Home Inspection Report',
  ddra: 'DDRA',
  uniqueReport: 'Unique Report',
  preListPictures: 'Pre-List Pictures',
  supportingReports: 'Supporting Report',
  wdoReport: "WDO Report",
  structuralEng: "Structural Eng",
  wellReport: "Well Report",

  processReport: 'Uploading...',
  processed: 'Uploaded',
  notProcessed: 'Upload Document',
  submitDocument: 'Upload document',
  clearFile: 'Clear file',
  manualProcessed: 'Uploaded',
  insReport: 'Solution Estimate Form',
  save: 'Save',
  addSolutionsToDB: "Add solutions to database",
  add: "Add",
  view: "View",
  viewEstimationTable: "View estimation table",
  beforeApprove: 'Approve to go to customer',
  afterApprove: 'Approved',
  notProcess: 'Not yet process this order',
  alterSolution: 'Alter Solution',
  auditLog: "Audit Log",
  fieldTable: {
    categoryNO: 'Category number',
    descPlace: 'R/R Description',
    keyWord: 'Keyword search',
    solution: 'Solution',
    cost: 'Cost',
    costOption: 'Cost Option',
    category: 'Category',
    categoryPlace: 'Pick one',
    desc: ' Category Desc',
    soluCategory: 'Category',
    link: 'Remove Row',
    image: 'Image',
    drag: 'Drag me',
    pagination: 'Items per page',
    itemsNumbers: 'Item Numbers',
    description: 'Description',
    picture: 'Picture',
    keyWordsCollection: [
      "key prime category to new solution",
      "keyword 1 to new solution",
      "keyword 2 to new solution",
      "keyword 3 to new solution",
      "keyword 4 to new solution",
      "key phrase to new solution"
    ],
    keyValuesName: [
      'keyPrimCategory',
      'key1',
      'key2',
      'key3',
      'key4',
    ]
  },
  createSolution: 'Add New Solution Estimate Item',
  multipleSolution: 'Add 10 Solution Estimate Template',
  clearRow: 'Clear Row',
  print: 'Print Document',
  action: 'Action',
  edit: 'Edit',
  remove: 'Remove',
  saveDragSolution: 'Save Drag Solution',
  openImg: '* Right click the image and choose Open in new tab to see it in full size',
  close: 'Close',
  //Pdf
  downloadPdf: 'Save as Pdf',
  idLabel: 'Unique Code',
  printHead: 'spekwo Solution Estimate',
  preListPrintHead: 'PRE-LIST SPEK-SHEET',
  scheduleInfoTitle: 'Scheduling Info',
  idContent: 'to view your solution estimate or approve work go to  client.spekwo.com   and enter your unique ID. ',
  noInsreportId: 'Unique id will be generated only after we create solution.',
  agent: 'Agent',
  client: 'Client',
  buyerAddress: 'Property Address',
  pdfFooter1: {
    head: 'Who, What,  spekwo, Huh?',
    'one': 'Glad you asked. spekwo is a trusted and neutral party for buyers and sellers. spekwo will create an estimate for the items your home inspection identified as “repair/ replace”.',
    'two': 'We do this by utilizing the most recent data on cost of available labor and materials. ',
    'three': 'If the ordering party elects to have any of the work done a spekwo approved Pro will complete the work at the above price, Guaranteed!'
  },
  pdfFooter2: {
    head: 'How does unique ID work?',
    'one': 'Each spekwo solution estimate completed comes with a unique ID which is a 5 character code. If you would like to view a copy of your home inspection report (the one you submitted)  Or If you would like to view your solution estimate or even if you would like to request some or all of the work quoted to be completed… you can do that all here! ',
    'two': 'Easy just go to ',
    'three': 'and enter your spekwo unique ID, which for yours is: '
  },
  pdfFooter3: {
    head: 'Who is speKwo and What do they do?',
    'one': `We are glad you asked . speKwo is a trusted and neutral party providing quotes for both buyers and sellers.`,
    'two': 'speKwo creates quotes just like this one for our broker clients.  We do this with our proprietary system which quotes all items from your home inspection report utilizing empirical data of labor and material cost for our area.  Not only can we quote the work, but we can complete the work for the price quoted!',
    'three': 'Our team provides quotes and repairs for nearly every real estate firm in the area.',
    'fourth': 'All quotes are valid for 90 days. Quotes are based on pre-allocated measurements which may be subject to change.',
  },
  validQuote: 'This Quote is valid for the next 30 days, after which values may be subject to change.',
  pdfCost: 'Total Quote',

  totalCost: 'Total cost',
  editCategory: 'Edit Category',
  newCategory: 'Add Category',
  update: 'Update',
  updatePage: 'Update Page',
  repairSolutionTitle: "REPAIR SOLUTION",

  info: 'Info',
  owner: 'Owner',
  email: 'Email',
  phone: 'Phone',
  type: 'Type',
  address: 'Buyer Property Address',
  orderAdd: "Order's Address",
  acceptStatus: 'Accept Status',
  acceptBy: 'Accepted By',
  ifAccept: 'Accepted',
  ifNotAccept: 'Not yet accept',
  acceptDate: 'Accepted Date',
  rating: 'Rating',
  createdAt: 'Created at',
  noToggledList: "Client hasn't toggled any solution estimate yet",
  noWorkLIst: "Below options enabled only after client requests the work",
  noPicturesUpload: "No pictures Uploaded",
  saveOrRemove: "Save / Remove ",
  addWork: "Add Work Request Items",

  solutionPage: 'solutionPage',
  requestWorkPageApprove: 'requestWorkPageApprove',

  //after approve solution
  afterApproveSolution: 'After approving solution cannot edit and delete . You can click Alter Solution to Edit/Remove the solution.',
  clientName: 'Client Name:',
  sellingBroker: 'Selling Broker:',
  clientRequest: 'Timeline Request:',
  quoteRequested: 'Quote Requested:',
  quoteDelivered: 'Quote Delivered:',
  quoteCompleted: 'Your quote was completed in ',
  homePageRow1: 'You have just saved an average of 6 phone calls',
  homePageRow2: 'and 11 hours in coordinating, meeting, and waiting',
  homePageRow3: 'for multiple quotes.',
  haveQuestions: 'Have Questions? Call us 866.646.0200 or Email us info@speKwo.com',
  page: 'Page',
  whoSpekwo1: 'Who is speKwo and what do they do? Glad you asked. We are company who provides Quotes and Repairs for all items on the home inspection. We are a neutral 3rd party who will provide the same exact quote to the seller as we do for the buyer. We do this with our proprietary system which quotes all items from the home inspection in 72 hours or less. Our quotes are accurate and so reliable we can complete the work for the price we quoted!',
  thankYou: 'Thank you for choosing speKwo and allowing us to provide you with accurate quotes and reliable repairs. We are a neutral party. We conduct repairs and quotes for all sides of the real estate transaction. Our pricing is the same for The seller as it is for the buyer. Our quotes are not swayed by the real estate market or the participants in it. Our quote is considered by industry experts to be credible and transparent.',
  xRay1: 'X-ray Vision:',
  xRay2: 'This is a technology all of us would like to have to avoid surprises behind walls and floors.  We also don’t have it. The large majority of the items from your recent inspection are clear. Our repair description and our prices reflect that. It is not our goal or intention to start repair work only to change the pricing. We believe in honest, transparent pricing structure',
  allGood1: 'All good',
  allGood2: 'All speKwo solution estimates are good for 60 days. Quotes are provided based on chronicled data, inspector descriptions & pictures, pricing catalogues, and the amount of time and materials it will take for our team to complete the task at hand.  These quotes are given to you with specific quantities, square or lineal footage, and in detailed decription of how repair will occur. By providing you the quote in this manner it makes our pricing fully transparent.',
  viewSolution: 'To View your Solution Estimate or Schedule repairs',
  supportingInfo: "supporting Notes",
  supportFor: "supporting Notes for ",
  fullSpekwo: 'HIQFULL',
  specificItem: 'CGPYWCK',
  preList: 'RJCZPSJ',
  office: 'Office.866.646.0200',
  webSite: 'Website: speKwo.com',
  emails: 'Email: Info@speKwo.com',
  commonQA: 'Common Questions, Honest Answers.',
  quoteComeFrom: 'This quote was requested and  paid for by someone associated with this transaction. The average quote take 3-5 hours to prepare so We don’t make a habit of providing unwanted quotes.',
  wroteThisQuote: 'Our quoting team is made up of actual humans who have retired from their career in trades.',
  firmsSpeKwoWorkWith: 'We work with large firms & boutique firms, solo agents & teams. Ask for us about it  we probably know the same people.',
  whyWorkWithSpeKwo: 'In every transaction both sides seek an equitable agreement. We provide the same quote, the same repairs, and the same level of service to all parties in the transaction. If our quote was provided to a seller, the buyer can call us after closing and get the same pricing.',
  whenCanDoRepairs: 'We can complete repairs PRE or POST close.  We will complete the repairs for the Buyer, Seller, Broker or anyone else who thinks we’re awesome.',
  whenCanBeHere: 'I am sure the answer you want to hear is “we can be there this afternoon”.  The more realistic answer is we can have a team to you in 7-10 days. We prioritize All PRE-Close repairs. We will clearly and constantly communicate with you on when we will be there so you can plan accordingly.',
  repairProcessWork: 'Our hope is to make this as painless as possible. You will not be receiving multiple calls or multiple visits from various strangers. You will have one point of contact in our office for scheduling and invoicing.  You will have one repair team equipped to handle the items you have requested.',
  whoDoingRepairs: 'Our repair team consists of full-time employees who are professional tradesmen. They enjoy their work and take pride in a quality outcome.',
  canRepairsPaid: 'Yes assuming one broker in the transaction has worked with speKwo previously we have a simple protocol in place allowing the final invoice to be paid from closing.'
}

export const solutionEstimateButton = [
  {
    key: "ready_to_quote",
    value: "Submit for Ready to Quote",
    respectiveStatus: "initiate",
    nextStatus: "ready_to_estimate"
  },
  {
    key: "level_1_review",
    value: "Submit for Level 1 Review",
    respectiveStatus: "ready_to_estimate",
    nextStatus: "first_review"
  },
  {
    key: "level_2_review",
    value: "Submit for Level 2 Review",
    respectiveStatus: "first_review",
    nextStatus: "second_review"
  },
  {
    key: "final_review",
    value: "Submit for Final Review",
    respectiveStatus: "second_review",
    nextStatus: "final_review"
  },
  {
    key: "approve_to_client",
    value: "Approve to client",
    respectiveStatus: "final_review",
    nextStatus: "se_complete"
  },
  {
    key: "approve_to_client",
    value: "Approve to client",
    respectiveStatus: "se_complete",
    nextStatus: "se_complete"
  },
  {
    key: "approve_to_client",
    value: "Approve to client",
    respectiveStatus: "cancel_work_request",
    nextStatus: "se_complete"
  },
]



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/e-commerce/spekwoType.ts